import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v38.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { v4 as t } from "uuid";
import e from "lodash";
import i from "@arcgis/core/layers/GraphicsLayer";
import * as s from "@arcgis/core/geometry/geometryEngine";
import * as r from "@arcgis/core/geometry/support/jsonUtils";
import a from "@arcgis/core/Graphic";
import o from "@arcgis/core/geometry/Multipoint";
import n from "@arcgis/core/geometry/Point";
import { ah as h, ax as l } from "../api/rec.js";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import { T as c } from "../index.js";
import "@arcgis/core/geometry/Polygon";
import { B as d } from "../base-toolbar.js";
import { M as p } from "../utils/map.js";
import { T as u, c as m, C as g, I as y, d as S } from "../enums.js";
import { L as _, A as b } from "../utils/auto-pan.js";
import { G } from "../geometry/creator.js";
import { G as f, b as T, A as I } from "../geometry/utils.js";
import { S as L } from "../symbols.js";
import { H as D } from "../history-manager.js";

var v = "POINTGUID",
    w = _objectSpread(_objectSpread({}, h), {}, {
  fieldGuid: "fieldGuid"
}),
    P = [u.SamplingAddSelect, u.SamplingComposite];

var A;
!function (t) {
  t.TISSUE = "eventSampleTissuePointGuid", t.SOIL = "soilSamplePointGuid";
}(A || (A = {}));

var tuple = function tuple() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  return t;
},
    M = {
  CENTER: 0,
  RANDOM: 1,
  AUTO: 3
},
    isSampleLabelComposite = function isSampleLabelComposite(t) {
  return t.some(function (e) {
    return t.some(function (t) {
      var i = "attributes" in e ? e.attributes[w.sampleID] : e.sampleId,
          s = "attributes" in t ? t.attributes[w.sampleID] : t.sampleId,
          r = "attributes" in e ? e.attributes[w.sequenceID] : e.sequenceId,
          a = "attributes" in t ? t.attributes[w.sequenceID] : t.sequenceId;
      return s === i && r !== a;
    });
  });
},
    updateSampleLabelSequence = function updateSampleLabelSequence(t, e) {
  t.clear();
  var i = 0,
      s = 0,
      r = "";
  e.sort(function (t, e) {
    var i = "attributes" in t ? t.attributes[w.fieldGuid] : t.fieldGuid,
        s = "attributes" in e ? e.attributes[w.fieldGuid] : e.fieldGuid,
        r = "attributes" in t ? t.attributes[w.sampleID] : t.sampleId,
        a = "attributes" in e ? e.attributes[w.sampleID] : e.sampleId,
        o = "attributes" in t ? t.attributes[w.sequenceID] : t.sequenceId,
        n = "attributes" in e ? e.attributes[w.sequenceID] : e.sequenceId;
    return (i && s ? i.localeCompare(s) : 0) || r - a || o - n;
  }), e.forEach(function (e) {
    var a = "attributes" in e ? v : A.SOIL in e ? A.SOIL : A.TISSUE,
        o = "attributes" in e ? e.attributes[w.sampleID] : e.sampleId,
        n = "attributes" in e ? e.attributes[w.fieldGuid] : e.fieldGuid;
    o == i && n == r || (i = o, s = 0), s += 1, r = n, t.set("attributes" in e ? e.attributes[a] : e[a], s);
  });
};

var SamplingTools = /*#__PURE__*/function (_d) {
  _inherits(SamplingTools, _d);

  var _super = _createSuper(SamplingTools);

  function SamplingTools(t, e) {
    var _this;

    _classCallCheck(this, SamplingTools);

    _this = _super.call(this, t, e), _this.id = "samples", _this.history = new D(), _this.gridHistory = new D(), _this.traceHistory = new D(), _this.clippedGridListeners = new _(), _this.gridListeners = new _(), _this.mapListeners = new _(), _this.traceListeners = new _(), _this.gridOrientationSettings = e.gridOrientationSettings, _this.gridLayer = _this.getLayer("GRID_LAYER"), _this.gridSymbol = L.fromJSON(c.symbols.sampling.grid), _this.gridLayer.visible = !1, _this.clippedGridLayer = _this.getLayer("CLIPPED_GRID_LAYER"), _this.clipSymbolDefault = L.fromJSON(c.symbols.sampling.clippedGrid.default), _this.clipSymbolHover = L.fromJSON(c.symbols.sampling.clippedGrid.hover), _this.clippedGridLayer.visible = !1, _this.selectionBoxSymbol = L.fromJSON(c.symbols.sampling.selectionBox), _this._createLayer([]), _this._createLabelLayer([]), _this.pointCreator = new G(_this.mapView, {
      drawLayer: _this.layer,
      geometryType: m.POINT,
      onDraw: function onDraw(t) {
        return _this._onDraw(t);
      },
      symbol: L.fromJSON(p.symbols.sampleSites.untraced.selected)
    }), _this.autoPan = new b(_this.mapView), _this.sites = [], _this.selectedSites = [], _this.guidProperty = null, _this.isBatch = !1, _this.transforms = [], _this.unTraced = !1, _this.viewOnly = !1, _this._sampleLabelDisplaySequence = new Map();
    return _this;
  }

  _createClass(SamplingTools, [{
    key: "_applyGridHistoryState",
    value: function _applyGridHistoryState(t) {
      this.gridCells = this._cloneGraphics(t), this._resetGrid(), this.forceUpdate();
    }
  }, {
    key: "_applyHistoryState",
    value: function _applyHistoryState(t) {
      var e = "toArray" in t ? t.toArray() : t;
      this.options.onRestoreAreaList(this.field.fieldGuid, this._getRestoreId(this.history.historyIndex), e), this.sites = this._cloneGraphics(t), this._clearSelections(), this.toggleTool({
        index: 0,
        selected: !0
      }), this._resetGraphics(), this.forceUpdate();
    }
  }, {
    key: "_applyToolListeners",
    value: function _applyToolListeners(t) {
      switch (this._updateMapCursor(), t) {
        case u.SamplingAddSelect:
        case u.SamplingComposite:
          this._createMapListeners();

          break;

        default:
          this._removeMapListeners();

      }
    }
  }, {
    key: "_applyTraceHistoryState",
    value: function _applyTraceHistoryState(t) {
      this.traceSites = this._cloneGraphics(t), this._sendTraceUpdate(), this._resetGraphics(), this.forceUpdate();
    }
  }, {
    key: "_areToolsDisabled",
    value: function _areToolsDisabled() {
      return this.mapView.scale > this.minScale;
    }
  }, {
    key: "_calculateGridDebounce",
    value: function _calculateGridDebounce(t, e) {
      var i = 1;

      if (Boolean(e > t)) {
        i = 100 / (t / e);
      }

      this._gridDebounce = i;
    }
  }, {
    key: "_clearGridVariables",
    value: function _clearGridVariables() {
      this._mouseDownOnGrid = !1;
    }
  }, {
    key: "_clearMapVariables",
    value: function _clearMapVariables() {
      this._drawSelectionBox = !1, this._isMovingPoint = !1, this._mouseDownOnGraphic = null, this._mouseDownPnt = null, this._mouseDownScreenPnt = null, this._mouseUpOnGraphic = !1, this._originalGraphics = [];
    }
  }, {
    key: "_clearSelections",
    value: function _clearSelections() {
      var _this2 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this.selectedSites.length > 0 && (this.selectedSites.length = 0, t || this._onUpdateSelectedSites()), this.layer && this.layer.graphics.forEach(function (t) {
        t.attributes.selected = 0, t.symbol = _this2._getSymbol(t);
      }), this.sites && this.sites.forEach(function (t) {
        t.attributes.selected = 0, t.symbol = _this2._getSymbol(t);
      });
    }
  }, {
    key: "_clearTrace",
    value: function _clearTrace() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this.isTracing = !1, this.unTraced = !!t && this.prevUnTraced, P.includes(this.activeTool) || this.autoPan.deactivate(), this._updateTraceSites([], !0, !1), this._removeTraceListeners(), this._resetGraphics();
    }
  }, {
    key: "_cloneGraphics",
    value: function _cloneGraphics(t) {
      return null == t ? [] : t.map(function (t) {
        return t.clone();
      });
    }
  }, {
    key: "_createClippedGridListeners",
    value: function _createClippedGridListeners() {
      var _this3 = this;

      this._removeClippedGridListeners();

      var _updateHover = function _updateHover(t, e) {
        t && (t.attributes.HOVER = e, t.symbol = 1 === e ? _this3.clipSymbolHover : _this3.clipSymbolDefault);
      };

      this.clippedGridListeners.add(this.mapView.on("pointer-move", function (t) {
        var e = {
          include: _this3.clippedGridLayer
        };

        _this3.mapView.hitTest(t, e).then(function (t) {
          if (t.results.length) {
            var _e = t.results[0].graphic;
            _updateHover(_this3._highlightedGrid, 0), _updateHover(_e, 1), _this3._highlightedGrid = _e;
          } else _this3._highlightedGrid && (_updateHover(_this3._highlightedGrid, 0), _this3._highlightedGrid = null);
        });
      }));
    }
  }, {
    key: "_createGridListeners",
    value: function _createGridListeners() {
      var _this4 = this;

      this._removeGridListeners();

      var _getAngle = function _getAngle(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4._gridCenter;
        return 180 * Math.atan2(t.y - e.y, t.x - e.x) / Math.PI;
      },
          _transformGridCells = function _transformGridCells(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return new Promise(function (i) {
          setTimeout(function () {
            var r = t.button,
                a = t.buttons,
                o = t.native,
                n = _this4.mapView.toMap(t);

            if (_this4._mouseDownOnGrid) {
              if (2 === r || 2 === a || o.ctrlKey) {
                var _t = _getAngle(n) - _getAngle(_this4._mouseDownGridPnt);

                _this4.gridLayer.graphics.forEach(function (e) {
                  var i = _this4._origGrids.find(function (t) {
                    return t.attributes.id === e.attributes.id;
                  });

                  e.geometry = s.rotate(i.geometry, _t, _this4._gridCenter), e.symbol = _this4.gridSymbol;
                }), e && (_this4.transforms.push({
                  rotationAngle: _t
                }), _this4.gridOrientationSettings = _objectSpread(_objectSpread({}, _this4.gridOrientationSettings), {}, {
                  rotation: _t
                }), _this4.options.onSetGridOrientationSettings(_this4.gridOrientationSettings));
              } else {
                var _t2 = n.x - _this4._mouseDownGridPnt.x,
                    _i = n.y - _this4._mouseDownGridPnt.y;

                _this4.gridLayer.graphics.forEach(function (e) {
                  var s = _this4._origGrids.find(function (t) {
                    return t.attributes.id === e.attributes.id;
                  });

                  e.geometry = f.transformTranslate(s.geometry, _t2, _i), e.symbol = _this4.gridSymbol;
                }), e && (_this4.transforms.push({
                  dx: _t2,
                  dy: _i
                }), _this4.gridOrientationSettings = _objectSpread(_objectSpread({}, _this4.gridOrientationSettings), {}, {
                  offsetX: _t2,
                  offsetY: _i
                }), _this4.options.onSetGridOrientationSettings(_this4.gridOrientationSettings));
              }

              _this4.options.onSetMapIsLoading(!1), i();
            } else _this4.options.onSetMapIsLoading(!1);
          });
        });
      };

      this.gridListeners.add(this.mapView.on("pointer-move", function (t) {
        var e = {
          include: [_this4.layer, _this4.gridLayer]
        };

        _this4.mapView.hitTest(t, e).then(function (t) {
          t.results.length ? (_this4._updateMapCursor(g.pointer), _this4._overGrid = !0) : (_this4._updateMapCursor(), _this4._overGrid = !1);
        });
      })), this.gridListeners.add(this.mapView.on("pointer-down", function (t) {
        var e = {
          include: _this4.gridLayer
        };

        _this4.mapView.hitTest(t, e).then(function (e) {
          if (e.results.length) {
            var _e2 = _this4.mapView.toMap(t);

            _this4._mouseDownOnGrid = !0, _this4._mouseDownGridPnt = _e2, _this4._origGrids = _this4._cloneGraphics(_this4.gridLayer.graphics);

            var _i2 = _this4._origGrids instanceof Array ? _this4._origGrids : _this4._origGrids.toArray();

            _this4._gridCenter = s.union(_i2.map(function (t) {
              return t.geometry;
            })).extent.center;
          }
        });
      })), this.gridListeners.add(this.mapView.on("drag", e.debounce(function (t) {
        _this4._overGrid && (_this4.options.onSetMapIsLoading(!0), _this4._mouseDownOnGrid = !0, _transformGridCells(t), t.stopPropagation());
      }, this._gridDebounce, {
        leading: !0
      }))), this.gridListeners.add(this.mapView.on("pointer-up", function (t) {
        _transformGridCells(t, !0), _this4._mouseDownOnGrid = !1, _this4._updateGrids(_this4.gridLayer.graphics), 2 === t.button && (t.stopPropagation(), t.preventDefault());
      }));
    }
  }, {
    key: "_createLayer",
    value: function _createLayer(t) {
      this.minScale = c.layers.fields.minScale, this.layer = new i({
        id: "SAMPLING_SITES_LAYER",
        graphics: t,
        minScale: this.minScale
      }), this.mapView.map.add(this.layer);
    }
  }, {
    key: "_createLabelLayer",
    value: function _createLabelLayer(t) {
      this.labelLayer = new i({
        id: "SAMPLING_SITES_LABEL_LAYER",
        graphics: t,
        minScale: this.minScale
      }), this.mapView.map.add(this.labelLayer);
    }
  }, {
    key: "_createMapListeners",
    value: function _createMapListeners() {
      var _this5 = this;

      this._removeMapListeners(), this.mapListeners.add(this.mapView.on("drag", function (t) {
        if (!P.includes(_this5.activeTool)) return;

        var e = _this5.mapView.toMap(t);

        if (_this5._mouseDownOnGraphic) return _this5._isMovingPoint = !0, _this5.selectedSites.length > 1 && _this5.layer.graphics.toArray().forEach(function (t) {
          _this5._updateLabel(t, t.geometry);
        }), 0 !== _this5._originalGraphics.length && _this5._originalGraphics.find(function (t) {
          return t.attributes.POINTGUID === _this5._mouseDownOnGraphic.attributes.POINTGUID;
        }) || (_this5._clearSelections(!0), _this5._makeSelection(_this5._mouseDownOnGraphic), _this5._originalGraphics = _this5._cloneGraphics([_this5._mouseDownOnGraphic])), _this5._updateLabel(_this5._mouseDownOnGraphic, e), _this5._moveSelectedPoints(e), void t.stopPropagation();
        _this5.activeTool !== u.SamplingComposite ? (_this5._drawSelectionBox = !0, _this5.mapView.graphics.removeAll(), _this5.mapView.graphics.add(new a({
          geometry: f.getSelectionArea(_this5._mouseDownPnt, e),
          symbol: _this5.selectionBoxSymbol
        })), t.stopPropagation()) : t.stopPropagation();
      })), this.mapListeners.add(this.mapView.on("pointer-down", function (t) {
        _this5._mouseDownScreenPnt = t;
        var e = {
          include: _this5.layer
        };

        _this5.mapView.hitTest(t, e).then(function (e) {
          if (e.results.length) {
            var _t3 = e.results[0].graphic;
            if (!P.includes(_this5.activeTool)) return;
            _this5._mouseDownOnGraphic = _t3, _this5._mouseUpOnGraphic = !1, _this5._isMovingPoint = !1, _this5._originalGraphics = _this5._cloneGraphics(_this5.selectedSites);
            var _t3$geometry = _t3.geometry,
                _i3 = _t3$geometry.x,
                _s = _t3$geometry.y;
            _this5._mouseDownStartLocation = {
              x: _i3,
              y: _s
            };
          } else {
            var _e3 = _this5.mapView.toMap(t);

            _this5._drawSelectionBox = !1, _this5._mouseUpOnGraphic = !1, _this5._mouseDownPnt = _e3;
          }
        });
      })), this.mapListeners.add(this.mapView.on("pointer-up", function (t) {
        var e = {
          include: _this5.layer
        };

        _this5.mapView.hitTest(t, e).then(function (e) {
          var i = _toConsumableArray(_this5.selectedSites);

          if (e.results.length) {
            var _s2 = e.results[0].graphic;
            if (!P.includes(_this5.activeTool) || !_this5._mouseDownOnGraphic) return;

            if (_this5._mouseUpOnGraphic = !0, _this5._isMovingPoint) {
              var _e4 = _this5.mapView.toMap(t);

              return void _this5._moveSelectedPoints(_e4, !0);
            }

            _this5._clearSelections(!0), _this5._makeSelection(_s2, i);
          } else {
            var _e5 = _this5.mapView.toMap(t);

            if (_this5._isMovingPoint) return void _this5._moveSelectedPoints(_e5, !0);

            if (_this5.usingGrid) {
              var _t4 = _this5.clippedGridLayer.graphics.find(function (t) {
                return t.geometry.contains(_e5);
              });

              if (_t4) {
                var _e6 = _this5.layer.graphics.find(function (e) {
                  return _t4.geometry.contains(e.geometry);
                });

                _e6 && _this5.activeTool !== u.SamplingComposite && _this5._makeSelection(_e6, i, !0);
              }
            } else if (_this5._drawSelectionBox) {
              var _e7 = _this5.mapView.toMap(t),
                  _i4 = _toConsumableArray(_this5.selectedSites);

              _this5._makeSelectionsInArea(f.getSelectionArea(_this5._mouseDownPnt, _e7), !0), _this5._finishSelection(_i4);
            }
          }

          _this5._onUpdateSelectedSites(), _this5.forceUpdate(), _this5._clearMapVariables();
        });
      })), this.mapListeners.add(this.mapView.on("pointer-move", function (t) {
        var e = {
          include: _this5.layer
        };

        _this5.mapView.hitTest(t, e).then(function (t) {
          t.results.length ? (_this5._updateMapCursor(g.pointer), _this5._overPoint = !0) : (_this5._updateMapCursor(), _this5._overPoint = !1);
        });
      }));
    }
  }, {
    key: "_findOriginalGridCell",
    value: function _findOriginalGridCell(t) {
      if (!this.usingGrid) return null;

      var e = this._originalGraphics.find(function (e) {
        return e.attributes.POINTGUID === t.attributes.POINTGUID;
      });

      return this.clippedGridLayer.graphics.find(function (t) {
        return t.geometry.contains(e.geometry);
      });
    }
  }, {
    key: "_getBasicSamplePointAttributes",
    value: function _getBasicSamplePointAttributes(t) {
      var _ref;

      return _ref = {}, _defineProperty(_ref, w.sampleID, t.sampleId), _defineProperty(_ref, w.sequenceID, t.sequenceId), _defineProperty(_ref, "fieldGuid", t.fieldGuid), _defineProperty(_ref, "isNew", !!t.isNew), _defineProperty(_ref, "selected", 0), _defineProperty(_ref, "traced", 1), _defineProperty(_ref, "labelMethod", t.labelMethod), _ref;
    }
  }, {
    key: "_getSoilAttributes",
    value: function _getSoilAttributes(e, i) {
      var _objectSpread2;

      return _objectSpread(_objectSpread({}, e), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, A.SOIL, i && null != i[this.guidProperty] ? i[this.guidProperty] : t()), _defineProperty(_objectSpread2, "samplePointDepths", null == i ? void 0 : i.samplePointDepths), _objectSpread2));
    }
  }, {
    key: "_getTissueAttributes",
    value: function _getTissueAttributes(e, i) {
      var _objectSpread3;

      return _objectSpread(_objectSpread({}, e), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, A.TISSUE, i && null != i[this.guidProperty] ? i[this.guidProperty] : t()), _defineProperty(_objectSpread3, "cropGrowthStageGuid", null == i ? void 0 : i.cropGrowthStageGuid), _defineProperty(_objectSpread3, "plantPartGuid", null == i ? void 0 : i.plantPartGuid), _objectSpread3));
    }
  }, {
    key: "_moveSelectedPoints",
    value: function _moveSelectedPoints(t) {
      var _this6 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var _this$_mouseDownStart = this._mouseDownStartLocation,
          i = _this$_mouseDownStart.x,
          s = _this$_mouseDownStart.y,
          r = i - t.x,
          a = s - t.y,
          o = [];

      if (this._originalGraphics.forEach(function (t) {
        var e = _this6.layer.graphics.find(function (e) {
          return e.attributes.POINTGUID === t.attributes.POINTGUID;
        }),
            _t$geometry = t.geometry,
            i = _t$geometry.x,
            s = _t$geometry.y,
            h = _t$geometry.spatialReference,
            l = i - r,
            c = s - a;

        e.geometry = new n({
          x: l,
          y: c,
          spatialReference: h
        }), o.push(e);
      }), e) {
        if (o.some(function (t) {
          return !_this6._isValidSiteLocation(t, _this6._originalGraphics, _this6._findOriginalGridCell(t));
        })) this._resetMove();else {
          var _t5 = this._cloneGraphics(this.layer.graphics);

          this._updateSites(_t5);
        }

        this._clearMapVariables();
      }
    }
  }, {
    key: "_resetMove",
    value: function _resetMove() {
      var _this7 = this;

      this._originalGraphics.forEach(function (t) {
        _this7.layer.graphics.find(function (e) {
          return e.attributes.POINTGUID === t.attributes.POINTGUID;
        }).set("geometry", t.geometry);
      }), this.sites = this._cloneGraphics(this.layer.graphics), this._setLabel();
    }
  }, {
    key: "_onDraw",
    value: function _onDraw(t) {
      var _this8 = this;

      if (!t.finished || this._overPoint) return;

      var e = this.mapView.toScreen(t.geometry),
          i = t.geometry,
          s = _toConsumableArray(this.selectedSites);

      if (this._clearSelections(!0), f.arePointsWithinTolerance(this._mouseDownScreenPnt, e, 2)) {
        var addSite = function addSite(t, e, i) {
          var r = new a({
            geometry: t
          });
          if (_this8.addSite(r, e, i)) return _this8._makeSelection(r, e), _this8._finishSelection(s), _this8._updateMapCursor(g.pointer), void (_this8._overPoint = !0);

          _this8.options.onSetMapIsLoading(!1);
        };

        if (this.usingGrid) {
          var _t6 = this.clippedGridLayer.graphics.find(function (t) {
            return t.geometry.contains(i);
          });

          if (_t6) {
            if (this.layer.graphics.find(function (e) {
              return _t6.geometry.contains(e.geometry) && e.attributes.POINTGUID;
            }) && this.activeTool !== u.SamplingComposite) return;
            addSite(i, s, _t6);
          }
        } else addSite(i, s);
      }
    }
  }, {
    key: "_createTraceListeners",
    value: function _createTraceListeners() {
      var _this9 = this;

      this._removeTraceListeners();

      var _applyTraceAttributes = function _applyTraceAttributes(t, e, i) {
        t.attributes[w.sampleID] = i, t.attributes[w.sequenceID] = e.length + 1, t.attributes.traced = 1, t.symbol = _this9._getSymbol(t), e.push(t);
      },
          _autoTrace = function _autoTrace(t, e) {
        return _this9.options.onSetMapIsLoading(!0), new Promise(function (i, s) {
          setTimeout(function () {
            try {
              var _s3 = I.BottomToTop;
              t.attributes.col < e.attributes.col ? _s3 = I.LeftToRight : t.attributes.col > e.attributes.col ? _s3 = I.RightToLeft : t.attributes.row < e.attributes.row && (_s3 = I.TopToBottom);

              var _r = _this9.clippedGridLayer.graphics.reduce(function (t, _ref2) {
                var e = _ref2.attributes;
                return [e.row > t[0] ? e.row : t[0], e.col > t[1] ? e.col : t[1]];
              }, [0, 0]),
                  _a = _this9.clippedGridLayer.graphics.reduce(function (t, _ref3) {
                var e = _ref3.attributes;
                return [e.row < t[0] ? e.row : t[0], e.col < t[1] ? e.col : t[1]];
              }, [_r[0], _r[1]]);

              var _o;

              switch (_s3) {
                case I.TopToBottom:
                case I.BottomToTop:
                  _o = t.attributes.col > _r[1] - (_r[1] - _a[1]) / 2 ? I.RightToLeft : I.LeftToRight;
                  break;

                case I.LeftToRight:
                case I.RightToLeft:
                  _o = t.attributes.row > _r[0] - (_r[0] - _a[0]) / 2 ? I.BottomToTop : I.TopToBottom;
              }

              var _n = tuple(e.attributes.row, e.attributes.col, _s3),
                  _h = tuple(_r[0], _r[1]);

              var _l = f.getAutoTraceNextCell(_n, _h, _o),
                  _c = _getTracedPoints();

              var getGridCell = function getGridCell(t, e) {
                return t.find(function (_ref4) {
                  var t = _ref4.attributes;
                  return t.row === e[0] && t.col === e[1];
                });
              };

              var _loop = function _loop() {
                var t = getGridCell(_this9.clippedGridLayer.graphics, _l);

                if (t) {
                  var _e8 = _this9.traceSites.find(function (e) {
                    return t.geometry.contains(e.geometry);
                  });

                  _e8 && (_c = _trace(_e8, t, _this9.layer.graphics));
                }

                var e = tuple(_l[0], _l[1], _l[2]);
                _l = f.getAutoTraceNextCell(e, _h, _o);
              };

              for (; _c.length < _this9.layer.graphics.length && (_n[0] !== _l[0] || _n[1] !== _l[1] || _n[2] !== _l[2]);) {
                _loop();
              }

              _this9._autoTraceComplete = !0, _this9._updateTraceSites(_this9.layer.graphics), _this9._resetGraphics(), i();
            } catch (r) {
              s(r);
            }
          });
        }).catch(function (t) {
          console.error(t);
        }).finally(function () {
          return _this9.options.onSetMapIsLoading(!1);
        });
      },
          _checkTrace = function _checkTrace(t, e) {
        _trace(t, e, _this9.layer.graphics), _this9.isAutoTracing && null != _this9._firstGridCell && !_this9._autoTraceComplete ? _autoTrace(_this9._firstGridCell, e) : (_this9.isAutoTracing && null == _this9._firstGridCell && (_this9._firstGridCell = e), _this9._updateTraceSites(_this9.layer.graphics), _this9._resetGraphics());
      },
          _getTracedPoints = function _getTracedPoints() {
        return _this9.traceSites.filter(function (t) {
          return 1 === t.attributes.traced;
        });
      },
          _trace = function _trace(t, e, i) {
        var s = _getTracedPoints(),
            r = i.find(function (e) {
          return e.attributes.POINTGUID === t.attributes.POINTGUID;
        });

        if (1 === r.attributes.traced) return s;

        var a = _this9._getNextId(s, w.sampleID);

        _applyTraceAttributes(r, s, a);

        return i.filter(function (t) {
          return 1 !== t.attributes.traced && e.geometry.contains(t.geometry);
        }).forEach(function (t) {
          _applyTraceAttributes(t, s, a);
        }), s;
      };

      this.traceListeners.add(this.mapView.on("pointer-move", function (t) {
        var e = {
          include: _this9.clippedGridLayer
        };

        _this9.mapView.hitTest(t, e).then(function (t) {
          if (t.results.length) {
            var _e9 = t.results[0].graphic,
                _i5 = _this9.traceSites.find(function (t) {
              return _e9.geometry.contains(t.geometry);
            });

            if (!_i5 || _i5 && 1 === _i5.attributes.traced) return;

            _checkTrace(_i5, _e9);
          }
        });

        var i = {
          include: _this9.layer
        };

        _this9.mapView.hitTest(t, i).then(function (t) {
          if (t.results.length) {
            var _e10 = t.results[0].graphic;
            if (1 === _e10.attributes.traced) return;

            var _i6 = _this9.clippedGridLayer.graphics.find(function (t) {
              return t.geometry.contains(_e10.geometry);
            });

            _checkTrace(_e10, _i6);
          }
        });
      }));
    }
  }, {
    key: "_deleteSelectedSites",
    value: function _deleteSelectedSites() {
      var _this10 = this;

      if (this.isBatchSampling()) {
        var _this$options = this.options,
            _t7 = _this$options.formatMessage,
            _e11 = _this$options.messages;
        return this.options.onDisplayMessage(_t7(_e11.invalidBatchEditMsg)), !1;
      }

      var t = this.sites.filter(function (t) {
        return 0 === t.attributes.selected;
      });

      if (!this.unTraced && !this.viewOnly) {
        var _e12 = new Map(),
            _i7 = new Map(),
            _s4 = Math.min.apply(Math, _toConsumableArray(this.sites.map(function (t) {
          return t.attributes[w.sampleID];
        }).filter(function (t) {
          return t;
        }))),
            _r2 = this.sites.every(function (t) {
          return t.attributes[w.sampleID] === _s4 || _this10.sites.some(function (e) {
            return e.attributes[w.sequenceID] !== t.attributes[w.sequenceID] && e.attributes[w.sampleID] === t.attributes[w.sampleID] - 1;
          });
        });

        t.forEach(function (a) {
          var o = a.attributes[w.sampleID],
              n = a.attributes[w.sequenceID],
              h = new Set(t.filter(function (t) {
            return t.attributes[w.sequenceID] < n;
          }).map(function (t) {
            return t.attributes[w.sequenceID];
          })).size + 1;

          if (_i7.set(n, h), o !== _s4 && _r2) {
            if (_r2 && !_e12.has(o)) {
              var _i8 = new Set(t.filter(function (t) {
                return t.attributes[w.sampleID] < o;
              }).map(function (t) {
                return t.attributes[w.sampleID];
              })),
                  _r3 = _i8.size + _s4;

              _e12.set(o, _r3);
            }
          } else _e12.set(o, o);
        }), t.forEach(function (t, s) {
          t.attributes[w.sampleID] = _e12.get(t.attributes[w.sampleID]), t.attributes[w.sequenceID] = _i7.get(t.attributes[w.sequenceID]);
        });
      }

      this.activeTool === u.SamplingComposite && this.toggleTool({
        selected: !1
      }, !1), this._updateSites(t), this._clearSelections(), this._resetGraphics();
    }
  }, {
    key: "_finishSelection",
    value: function _finishSelection(t) {
      this._drawSelectionBox = !1, this.mapView.graphics.removeAll(), this.activeTool === u.SamplingComposite && 1 !== this.selectedSites.length && (0 === this.selectedSites.length && 1 === t.length ? this._makeSelection(t[0], [], !0) : this.toggleTool({
        selected: !1
      }, !1));
    }
  }, {
    key: "_getLabelSymbol",
    value: function _getLabelSymbol(t) {
      var e = L.fromJSON(p.symbols.sampleSites.label.text);

      var i = this._sampleLabelDisplaySequence.get(t.attributes.POINTGUID);

      var s = (t.attributes.labelMethod ? t.attributes.labelMethod === l.COMPOSITE : this._getShowSequence()) ? "".concat(t.attributes[w.sampleID], " - ").concat(i) : "".concat(t.attributes[w.sampleID]);
      return e.text = s, e;
    }
  }, {
    key: "_getNextId",
    value: function _getNextId(t, e) {
      var i = [];
      return t.forEach(function (t) {
        i.push(t.attributes[e]);
      }), Math.max.apply(Math, i.concat([0])) + 1;
    }
  }, {
    key: "_getRestoreId",
    value: function _getRestoreId(t) {
      return "".concat(this.id, "-").concat(t);
    }
  }, {
    key: "_getShowSequence",
    value: function _getShowSequence() {
      var _this11 = this;

      return this.sites.some(function (t) {
        return _this11.sites.some(function (e) {
          return e.attributes[w.sampleID] === t.attributes[w.sampleID] && e.attributes[w.sequenceID] !== t.attributes[w.sequenceID];
        });
      });
    }
  }, {
    key: "_getSymbol",
    value: function _getSymbol(t) {
      var e = 1 === t.attributes.selected,
          i = 1 === t.attributes.traced;
      return e ? i ? L.fromJSON(p.symbols.sampleSites.selected) : L.fromJSON(p.symbols.sampleSites.untraced.selected) : i ? L.fromJSON(p.symbols.sampleSites.default) : L.fromJSON(p.symbols.sampleSites.untraced.default);
    }
  }, {
    key: "_isValidSiteLocation",
    value: function _isValidSiteLocation(t, e, i) {
      var s = this.options.formatMessage,
          r = t.geometry,
          a = [r];

      if (this.activeTool === u.SamplingComposite && null != e && null != i && e.forEach(function (t) {
        a.push(t.geometry);
      }), this.options.getInterpolationType() === y.ZONE_SAMPLING && this._isInvalidZoneSamplingSite(t, e)) {
        var _t8 = this.options.messages;
        return this.options.onPushToasterMessage(s(_t8.invalidZoneSamplingSiteMsg), S.ERROR), !1;
      }

      var o = this.samplingArea && this.samplingArea.contains(r);
      if (!i) return o;
      var n = i.geometry;
      return this.samplingArea && this.samplingArea.contains(r) && (!i || i && !a.some(function (t) {
        return !n.contains(t);
      }));
    }
  }, {
    key: "_isInvalidZoneSamplingSite",
    value: function _isInvalidZoneSamplingSite(t, e) {
      var i = this.zoneGeometries.find(function (e) {
        return e.contains(t.geometry);
      }),
          s = t.attributes.SampleId,
          r = this.activeTool === u.SamplingComposite ? e[0].attributes.SampleId : null;
      return i && this.sites.some(function (t) {
        return i.contains(t.geometry) && t.attributes.SampleId !== s && t.attributes.SampleId !== r;
      });
    }
  }, {
    key: "_makeSelection",
    value: function _makeSelection(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      e.find(function (e) {
        return e.attributes.POINTGUID === t.attributes.POINTGUID;
      }) ? this.selectedSites = this.selectedSites.filter(function (e) {
        return e.attributes.POINTGUID !== t.attributes.POINTGUID;
      }) : (t.attributes.selected = 1, t.symbol = this._getSymbol(t), this.selectedSites.push(t)), i || this._onUpdateSelectedSites();
    }
  }, {
    key: "_makeSelectionsInArea",
    value: function _makeSelectionsInArea(t) {
      var _this12 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      this.layer.graphics.forEach(function (e) {
        t.contains(e.geometry) && _this12._makeSelection(e, [], !0);
      }), e || this._onUpdateSelectedSites();
    }
  }, {
    key: "_onUpdateSelectedSites",
    value: function _onUpdateSelectedSites() {
      var t = new Set(this.selectedSites.map(function (t) {
        return t.attributes.POINTGUID;
      }));
      this.options.onUpdateSelectedSites(t);
    }
  }, {
    key: "_removeClippedGridListeners",
    value: function _removeClippedGridListeners() {
      this.clippedGridListeners.removeAll();
    }
  }, {
    key: "_removeGridListeners",
    value: function _removeGridListeners() {
      this._clearGridVariables(), this.autoPan.deactivate(), this.gridListeners.removeAll();
    }
  }, {
    key: "_removeMapListeners",
    value: function _removeMapListeners() {
      this._clearMapVariables(), this.mapListeners.removeAll();
    }
  }, {
    key: "_removeTraceListeners",
    value: function _removeTraceListeners() {
      this.traceListeners.removeAll();
    }
  }, {
    key: "_resetGraphics",
    value: function _resetGraphics() {
      var t = this.isTracing ? this._cloneGraphics(this.traceSites) : this._cloneGraphics(this.sites);
      !t || t && 0 === t.length && 0 === this.layer.graphics.length || (this.layer.removeAll(), this.layer.addMany(t), this._setLabel());
    }
  }, {
    key: "_resetGrid",
    value: function _resetGrid() {
      this.gridLayer.graphics.removeAll(), this.gridLayer.addMany(this.gridCells);
    }
  }, {
    key: "_sendTraceUpdate",
    value: function _sendTraceUpdate() {
      if (this.field) {
        var _t9 = this.traceSites.reduce(function (t, e) {
          return t + e.attributes.traced;
        }, 0);

        this.options.onUpdateTrace(this.field.fieldGuid, this.traceSites, _t9);
      }
    }
  }, {
    key: "_setLabel",
    value: function _setLabel() {
      var _this13 = this;

      if (this.layer) {
        var _t10 = [];
        this.layer.graphics.forEach(function (e) {
          e.attributes[w.sampleID] && _t10.push(new a({
            attributes: {
              POINTGUID: e.attributes.POINTGUID
            },
            geometry: e.geometry,
            symbol: _this13._getLabelSymbol(e)
          }));
        }), this.labelLayer.removeAll(), this.labelLayer.addMany(_t10);
      }
    }
  }, {
    key: "_setLabelMethod",
    value: function _setLabelMethod(t) {
      this.sites.forEach(function (e) {
        e.attributes.labelMethod = t;
      });
    }
  }, {
    key: "_unSelectTools",
    value: function _unSelectTools() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      [this.addSelectTool, this.compositeTool].some(function (t) {
        return !!t && (t.unselect(!0), !0);
      }), this._clearSelections(), this.menu && this.menu.toggleTool({
        selected: !1
      }), t || (this.initActivation({
        tool: null,
        activate: !1,
        byPassShare: !1,
        forceUpdate: e
      }, this._activateTool), this._applyToolListeners(null)), this.pointCreator.deactivate(), this._updateMapCursor(g.default), e && this.forceUpdate();
    }
  }, {
    key: "_updateGrids",
    value: function _updateGrids(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      this.gridCells = t;

      var i = this._cloneGraphics(t);

      this.gridHistory.add(i, e), this.forceUpdate();
    }
  }, {
    key: "_updateLabel",
    value: function _updateLabel(t, e) {
      if (!t || !t.attributes[w.sampleID]) return;
      var i = this.labelLayer.graphics.find(function (e) {
        return e.attributes.POINTGUID === t.attributes.POINTGUID;
      });
      this.labelLayer.remove(i);

      var s = this._getLabelSymbol(t),
          r = new a({
        attributes: {
          POINTGUID: t.attributes.POINTGUID
        },
        geometry: e,
        symbol: s
      });

      this.labelLayer.add(r);
    }
  }, {
    key: "_updateSiteAttributes",
    value: function _updateSiteAttributes(t) {
      var e = this.guidProperty === A.TISSUE,
          i = {
        isNew: Boolean(t.attributes.isNew),
        sampleId: t.attributes[w.sampleID],
        sequenceId: t.attributes[w.sequenceID],
        shape: JSON.stringify(t.geometry.toJSON()),
        fieldGuid: t.attributes.FIELDGUID || this.field.fieldGuid,
        batchSamplingEventGuid: t.attributes.BATCHSAMPLINGEVENTGUID,
        labelMethod: t.attributes.labelMethod
      };

      if (e) {
        return _objectSpread(_objectSpread({}, i), {}, {
          cropGrowthStageGuid: t.attributes.cropGrowthStageGuid,
          eventSampleTissuePointGuid: t.attributes.POINTGUID || t.attributes[A.TISSUE],
          plantPartGuid: t.attributes.plantPartGuid
        });
      }

      return _objectSpread(_objectSpread({}, i), {}, {
        samplePointDepths: t.attributes.samplePointDepths,
        soilSamplePointGuid: t.attributes.POINTGUID || t.attributes[A.SOIL]
      });
    }
  }, {
    key: "_updateSites",
    value: function _updateSites(t) {
      var _this14 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      this.sites = t, 0 === this.sites.length && this._clearSelections(), updateSampleLabelSequence(this._sampleLabelDisplaySequence, this.sites);

      var r = this._cloneGraphics(this.sites);

      if (e && this.field && this.options.onSaveAreaList(this.field.fieldGuid, this._getRestoreId(0)), this.history.add(r, e), i && this.field && this.guidProperty) {
        var _t11 = ("toArray" in this.sites ? this.sites.toArray() : this.sites).map(function (t) {
          return _this14._updateSiteAttributes(t);
        }).sort(function (t, e) {
          return _this14.usingGrid || t.sampleId === e.sampleId ? t.sequenceId - e.sequenceId : t.sampleId - e.sampleId;
        });

        this.options.onUpdateSites(this.field.fieldGuid, this.sites, _t11), this.options.onSaveAreaList(this.field.fieldGuid, this._getRestoreId(this.history.historyIndex));
      }

      this.forceUpdate();
    }
  }, {
    key: "_updateTraceSites",
    value: function _updateTraceSites(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      this.traceSites = t;

      var s = this._cloneGraphics(t);

      this.traceHistory.add(s, e), i && this._sendTraceUpdate(), this.forceUpdate();
    }
  }, {
    key: "_updateMapCursor",
    value: function _updateMapCursor(t) {
      if (t) this.mapView.container.style.cursor = t;else switch (this.activeTool) {
        case u.SamplingAddSelect:
        case u.SamplingComposite:
          this.mapView.container.style.cursor = g.crosshair;
          break;

        default:
          this.mapView.container.style.cursor = g.default;
      }
    }
  }, {
    key: "_activateTool",
    value: function _activateTool(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      e || this.options.onSetSharedToolsetTool(t), (e || null == t) && this._unSelectTools(!0, i), this._applyToolListeners(t), i && this.forceUpdate();
    }
  }, {
    key: "activateToolset",
    value: function activateToolset() {
      var _this15 = this;

      this.disabled ? this.reset().then(function () {
        return _this15._resetGraphics();
      }) : (this.activeTool ? this._activateTool(this.activeTool) : this._createMapListeners(), this._resetGraphics());
    }
  }, {
    key: "addSite",
    value: function addSite(e, i, s) {
      if (this.activeTool === u.SamplingComposite && (null == i || 1 !== i.length)) return this._unSelectTools(!1, !0), this._resetGraphics(), !1;
      var r = this.options.formatMessage;

      if (this.isBatchSampling()) {
        var _t12 = this.options.messages;
        return this.options.onDisplayMessage(r(_t12.invalidBatchEditMsg)), !1;
      }

      null == e.attributes && (e.attributes = {});

      var a = this._isValidSiteLocation(e, i, s);

      if (a) {
        if (!this.unTraced) if (this.activeTool === u.SamplingAddSelect ? (e.attributes[w.sampleID] = this._getNextId(this.sites, w.sampleID), e.attributes.labelMethod = this._getShowSequence() ? l.COMPOSITE : l.DEFAULT) : (console.assert(this.activeTool === u.SamplingComposite), console.assert(1 === i.length), e.attributes[w.sampleID] = i[0].attributes[w.sampleID], e.attributes.labelMethod = l.COMPOSITE, this._setLabelMethod(l.COMPOSITE)), this.usingGrid && this.activeTool === u.SamplingComposite && null != i && i.length > 0) {
          var _t13 = i[0].attributes[w.sequenceID];
          e.attributes[w.sequenceID] = _t13 + 1, this.sites.forEach(function (e) {
            e.attributes[w.sequenceID] > _t13 && (e.attributes[w.sequenceID] += 1);
          });
        } else if (this.viewOnly) e.attributes[w.sequenceID] = this._getNextId(this.sites, w.sequenceID);else {
          var _t14 = this.sites.reduce(function (t, e) {
            return Math.max(t, e.attributes[w.sequenceID]);
          }, 0);

          e.attributes[w.sequenceID] = _t14 + 1;
        }
        e.attributes.isNew = !0, e.attributes.POINTGUID = t(), e.attributes.traced = this.unTraced ? 0 : 1, e.attributes.selected = 1, e.attributes.BATCHSAMPLINGEVENTGUID = "", e.symbol = this._getSymbol(e);
        var _s5 = this.sites;
        _s5.push(e), this._updateSites(_s5);
      }

      return this._resetGraphics(), a;
    }
  }, {
    key: "applyGrid",
    value: function applyGrid() {
      var _this16 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      (t || this.showingGrid) && (this.showingGrid = !1, this.clippedGridLayer.removeAll(), this.gridCells.forEach(function (t, e) {
        if (s.intersects(t.geometry, _this16.samplingArea)) {
          var _i9 = s.intersect(t.geometry, _this16.samplingArea);

          _i9 && _this16.clippedGridLayer.add(new a({
            attributes: _objectSpread(_objectSpread({}, t.attributes), {}, {
              id: e,
              HOVER: 0
            }),
            geometry: _i9,
            symbol: _this16.clipSymbolDefault
          }));
        }
      }), this.clippedGridLayer.visible = !0, this.gridLayer.visible = !1, this._removeGridListeners(), this._createClippedGridListeners(), this._clearSelections());
    }
  }, {
    key: "cancel",
    value: function cancel() {
      return this._cancel = !0, this.clear();
    }
  }, {
    key: "cancelGrid",
    value: function cancelGrid() {
      this.unTraced = this._prevUnTraced, this._previousGridCells && (this._updateGrids(this._previousGridCells), this.applyGrid(!0)), this.layer.visible = !0, this._clearSelections();
    }
  }, {
    key: "cancelTrace",
    value: function cancelTrace() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this._clearTrace(!t), this._updateSites(this.sites), this._clearSelections();
    }
  }, {
    key: "canDelete",
    value: function canDelete() {
      return !this._areToolsDisabled() && this.selectedSites.length > 0 && (!this.isBatch || this.sites.length > 1);
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.history.canRedo();
    }
  }, {
    key: "canRedoGrid",
    value: function canRedoGrid() {
      return this.gridHistory.canRedo();
    }
  }, {
    key: "canRedoTrace",
    value: function canRedoTrace() {
      return this.traceHistory.canRedo();
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.history.canUndo();
    }
  }, {
    key: "canUndoGrid",
    value: function canUndoGrid() {
      return this.gridHistory.canUndo();
    }
  }, {
    key: "canUndoTrace",
    value: function canUndoTrace() {
      return this.traceHistory.canUndo();
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this17 = this;

      return this.layer.removeAll(), this.labelLayer.removeAll(), this.pointCreator.deactivate(), this.reset().then(function () {
        _this17.clearGrid(), _this17._updateSites([], !0, !1);
      });
    }
  }, {
    key: "clearGrid",
    value: function clearGrid() {
      this._removeGridListeners(), this.gridCells = null, this.usingGrid = !1, this.showingGrid = !1, this.unTraced = !1, this.transforms.length = 0, this.gridLayer.removeAll(), this.gridLayer.visible = !1, this.clippedGridLayer.removeAll(), this.clippedGridLayer.visible = !1, this.layer && (this.layer.visible = !0);
    }
  }, {
    key: "createGrid",
    value: function createGrid(t, e) {
      var _this18 = this;

      var i = this.usingGrid;
      this._previousGridCells = i ? this._cloneGraphics(this.gridCells) : null, this._gridDebounce = 1, this.usingGrid = !0, this.showingGrid = !0, this._prevUnTraced = this.unTraced, this.unTraced = !0, this.pointCreator.deactivate();

      var createGrid = function createGrid(r) {
        return setTimeout(function () {
          _this18.layer && (_this18.layer.visible = !1);
          var a = f.calculateMinMaxRangeForGridCells(_this18.gridArea),
              o = tuple(a[0], a[1]);
          _this18._calculateGridDebounce(t.areaAcres, a[0]), _this18.options.onSetMinMaxGridCell(a[0], a[1]), e && !i && (_this18.transforms = [], _this18.transforms.push({
            dx: e.offsetX,
            dy: e.offsetY,
            rotationAngle: e.rotation
          })), _this18._updateGrids(f.createGridCells(_this18.gridArea, t, o, _this18.gridSymbol), !0);

          var _iterator = _createForOfIteratorHelper(_this18.transforms),
              _step;

          try {
            var _loop2 = function _loop2() {
              var t = _step.value;
              var e = s.union(_this18.gridCells.map(function (t) {
                return t.geometry;
              })).extent.center;
              _this18.gridCells.forEach(function (i) {
                null != t.rotationAngle && (i.geometry = s.rotate(i.geometry, t.rotationAngle, e)), null != t.dx && null != t.dy && (i.geometry = f.transformTranslate(i.geometry, t.dx, t.dy));
              }), _this18._updateGrids(_this18.gridCells);
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          i && (_this18.traceSites = null, _this18.sites = [], _this18.labelLayer.removeAll()), _this18._resetGrid(), _this18.moveLayersToTop(), _this18._createGridListeners(), _this18.gridLayer.visible = !0, _this18.clippedGridLayer.visible = !1, r();
        });
      };

      return this.options.onSetMapIsLoading(!0), new Promise(function (t) {
        return createGrid(t);
      }).finally(function () {
        return _this18.options.onSetMapIsLoading(!1);
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      this.canDelete() && this._deleteSelectedSites();
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return {
        top: 0,
        left: 280,
        leftAndRight: !0,
        width: 220,
        height: 51
      };
    }
  }, {
    key: "getFieldBoundaryGeometries",
    value: function () {
      var _getFieldBoundaryGeometries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
        var i, s;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fieldsLayer.getFieldBoundaries(t);

              case 2:
                i = _context.sent;
                s = e.groupBy(i, function (t) {
                  return t.fieldGuid;
                });
                return _context.abrupt("return", e.reduce(s, function (t, e, i) {
                  var s = T.getCombinedBoundaries(e.map(function (t) {
                    return t.shape;
                  }));
                  return t.set(i, s), t;
                }, new Map()));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFieldBoundaryGeometries(_x) {
        return _getFieldBoundaryGeometries.apply(this, arguments);
      }

      return getFieldBoundaryGeometries;
    }()
  }, {
    key: "getTools",
    value: function getTools() {
      return [u.SamplingAddSelect, u.SamplingComposite];
    }
  }, {
    key: "getUpdatedSamplePoints",
    value: function getUpdatedSamplePoints(t) {
      var _this19 = this;

      return ("toArray" in t ? t.toArray() : t).map(function (t) {
        return _this19._updateSiteAttributes(t);
      }).sort(function (t, e) {
        return _this19.usingGrid || t.sampleId === e.sampleId ? t.sequenceId - e.sequenceId : t.sampleId - e.sampleId;
      });
    }
  }, {
    key: "isBatchSampling",
    value: function isBatchSampling() {
      return this.sites.some(function (t) {
        return null != t.attributes.BATCHSAMPLINGEVENTGUID && "" != t.attributes.BATCHSAMPLINGEVENTGUID;
      });
    }
  }, {
    key: "moveLayersToTop",
    value: function moveLayersToTop() {
      var _this20 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      t.forEach(function (t) {
        return _this20.moveLayerToTop(t);
      }), this.moveLayerToTop(this.clippedGridLayer), this.layer && (this.moveLayerToTop(this.layer), this.moveLayerToTop(this.labelLayer)), this.moveLayerToTop(this.gridLayer);
    }
  }, {
    key: "placePoints",
    value: function placePoints(e) {
      var _this21 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      if (this.placementMethod = e, this.gridCells && 0 !== this.gridCells.length) return i && this._updateSites([], !0), this.options.onSetMapIsLoading(!0), new Promise(function (i) {
        setTimeout(function () {
          _this21.applyGrid(r);

          var n = _this21.gridCells.find(function (t) {
            return 0 === t.attributes.id;
          }).geometry,
              h = Number(T.calculateArea(n)) * c.sampling.partialGridCellLimit,
              l = Math.max(s.distance(n.getPoint(0, 0), n.getPoint(0, 1), "feet"), s.distance(n.getPoint(0, 1), n.getPoint(0, 2), "feet")) * c.sampling.randomGridSiteDistance,
              d = _this21.sites.map(function (t) {
            return t.geometry;
          }),
              p = [],
              u = new o({
            spatialReference: n.spatialReference
          });

          _this21.clippedGridLayer.graphics.forEach(function (_ref5) {
            var i = _ref5.geometry;
            if (Number(T.calculateArea(i)) < h || f.polygonContainsAPoint(i, d)) return;
            var r = i.extent,
                o = -Math.max(r.width, r.height) * c.sampling.cellEdgeBuffer,
                n = s.buffer(i, o, "feet");
            var m;
            if (e === M.CENTER) m = f.getCenterPointInPolygon(n);else {
              console.assert(e === M.RANDOM);

              var _t15 = !1,
                  _i10 = 0;

              for (; !_t15 && _i10 < c.sampling.randomMaxAttempts;) {
                m = f.getRandomPointInPolygon(n), _t15 = 0 === u.points.length || s.distance(m, u, "feet") > l, _i10++;
              }
            }

            if (m && i.contains(m)) {
              var _attributes;

              u.addPoint(m);

              var _e13 = new a({
                geometry: m,
                attributes: (_attributes = {}, _defineProperty(_attributes, w.sampleID, null), _defineProperty(_attributes, w.sequenceID, null), _defineProperty(_attributes, "isNew", !0), _defineProperty(_attributes, v, t()), _defineProperty(_attributes, "selected", 0), _defineProperty(_attributes, "traced", 0), _defineProperty(_attributes, "BATCHSAMPLINGEVENTGUID", ""), _defineProperty(_attributes, "labelMethod", null), _attributes)
              });

              _e13.symbol = _this21._getSymbol(_e13), p.push(_e13);
            }
          }), _this21._updateSites([].concat(_toConsumableArray(_this21.sites), p), !0), p.length > 0 && (_this21.unTraced = !0), _this21._resetGraphics(), _this21.layer && (_this21.layer.visible = !0), i();
        });
      }).finally(function () {
        return _this21.options.onSetMapIsLoading(!1);
      });
    }
  }, {
    key: "placeFieldCenterPoints",
    value: function placeFieldCenterPoints(e, i) {
      var _this22 = this;

      return this.options.onSetMapIsLoading(!0), new Promise(function (s) {
        setTimeout(function () {
          var r = [],
              o = new Map();

          _this22.getFieldBoundaryGeometries(_toConsumableArray(_this22.fieldsLayer.getSelectedFieldGuids())).then(function (n) {
            n.forEach(function (t, e) {
              o.set(e, f.getPolyLabelPoint(t));
            }), o.forEach(function (s, o) {
              var _n2;

              var n = (_n2 = {}, _defineProperty(_n2, w.sampleID, 1), _defineProperty(_n2, w.sequenceID, 1), _defineProperty(_n2, "isNew", !0), _defineProperty(_n2, v, t()), _defineProperty(_n2, "selected", 0), _defineProperty(_n2, "traced", 0), _defineProperty(_n2, "FIELDGUID", o), _defineProperty(_n2, "BATCHSAMPLINGEVENTGUID", ""), _defineProperty(_n2, "labelMethod", l.DEFAULT), _n2),
                  h = i ? _this22._getTissueAttributes(n, e) : _this22._getSoilAttributes(n, e),
                  c = new a({
                geometry: s,
                attributes: h
              });
              c.symbol = _this22._getSymbol(c), r.push(c);
            }), _this22._updateSites([].concat(_toConsumableArray(_this22.sites), r), !0, !0, !0), r.length > 0 && (_this22.unTraced = !0), _this22._resetGraphics(), _this22.layer.visible = !0, s();
          });
        });
      }).finally(function () {
        return _this22.options.onSetMapIsLoading(!1);
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this23 = this;

      _get(_getPrototypeOf(SamplingTools.prototype), "redo", this).call(this, this.history, function (t) {
        return _this23._applyHistoryState(t);
      });
    }
  }, {
    key: "redoGrid",
    value: function redoGrid() {
      var _this24 = this;

      _get(_getPrototypeOf(SamplingTools.prototype), "redo", this).call(this, this.gridHistory, function (t) {
        return _this24._applyGridHistoryState(t);
      });
    }
  }, {
    key: "redoTrace",
    value: function redoTrace() {
      var _this25 = this;

      _get(_getPrototypeOf(SamplingTools.prototype), "redo", this).call(this, this.traceHistory, function (t) {
        return _this25._applyTraceHistoryState(t);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      return this._removeMapListeners(), this._updateMapCursor(g.default), this.setActiveTool(null), Promise.resolve();
    }
  }, {
    key: "resetTools",
    value: function resetTools() {
      var _this26 = this;

      setTimeout(function () {
        return _this26._unSelectTools();
      });
    }
  }, {
    key: "resetTrace",
    value: function resetTrace() {
      var _this27 = this;

      console.assert(this.isTracing);

      var t = this._cloneGraphics(this.sites);

      t.forEach(function (t) {
        t.attributes[w.sampleID] = null, t.attributes[w.sequenceID] = null, t.attributes.traced = 0, t.symbol = _this27._getSymbol(t);
      }), this.unTraced = !0, this._firstGridCell = null, this._autoTraceComplete = !1, this._updateTraceSites(t, !0), this._clearSelections(), this._resetGraphics(), this.labelLayer.removeAll();
    }
  }, {
    key: "setAutoTracing",
    value: function setAutoTracing(t) {
      this.isAutoTracing = t, this._firstGridCell = null, this._autoTraceComplete = !1;
    }
  }, {
    key: "setEntireField",
    value: function setEntireField(t) {
      this.gridArea = t.extent.expand(1.5);
    }
  }, {
    key: "setIncludedZones",
    value: function setIncludedZones(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this.zoneGeometries = t.map(function (t) {
        return t.geometry;
      }), this.zoneGeometries && this.zoneGeometries.length > 0 && (this.samplingArea = s.union(this.zoneGeometries)), e && this.usingGrid && !this.showingGrid && this.placePoints(this.placementMethod, !1, !0);
    }
  }, {
    key: "setSitesInfo",
    value: function setSitesInfo(e, i) {
      var _this28 = this;

      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      null != i && this.field !== i && (this.field = i), this.guidProperty = s ? A.TISSUE : A.SOIL;
      var o = e.map(function (e) {
        var i = _this28._getBasicSamplePointAttributes(e),
            o = s ? _this28._getTissueAttributes(i, e) : _this28._getSoilAttributes(i, e);

        o.BATCHSAMPLINGEVENTGUID = e.batchSamplingEventGuid, o.POINTGUID = null != e[_this28.guidProperty] ? e[_this28.guidProperty] : t();
        var n = r.fromJSON(JSON.parse(e.shape)),
            h = new a({
          geometry: n,
          attributes: o
        });
        return h.symbol = _this28._getSymbol(h), h;
      });
      this._updateSites(o, !0), this.moveLayersToTop(), this._resetGraphics();
    }
  }, {
    key: "setBatchSitesInfo",
    value: function setBatchSitesInfo(e, i, s, o, n) {
      var _this29 = this;

      if (this.isBatch = !0, null != i && i.length > 0 && (this.field = i.find(function (t) {
        return "BATCH_TEMPLATE" === t.fieldGuid;
      })), this.guidProperty = o ? A.TISSUE : A.SOIL, s && s.length > 0) return this.options.onSetMapIsLoading(!0), new Promise(function (e) {
        setTimeout(function () {
          var i = s.map(function (e) {
            var i = _this29._getBasicSamplePointAttributes(e),
                s = o ? _this29._getTissueAttributes(i, e) : _this29._getSoilAttributes(i, e);

            s.POINTGUID = null != e[_this29.guidProperty] ? e[_this29.guidProperty] : t();
            var n = r.fromJSON(JSON.parse(e.shape));
            return new a({
              geometry: n,
              attributes: s
            });
          });
          _this29.sites = i, _this29.options.onRestoreSites(i), i.length > 0 && (_this29.unTraced = !0), updateSampleLabelSequence(_this29._sampleLabelDisplaySequence, _this29.sites), _this29._resetGraphics(), _this29.layer && (_this29.layer.visible = !0), e();
        });
      }).finally(function () {
        return _this29.options.onSetMapIsLoading(!1);
      });
      this.placeFieldCenterPoints(e, o), this.moveLayersToTop(n), this.resetTools();
    }
  }, {
    key: "setTheActiveMapTool",
    value: function setTheActiveMapTool(t) {
      switch (t) {
        case u.SamplingAddSelect:
          this.menu.activateToolAtIndex(0), this.toggleTool({
            index: 0,
            selected: !0
          }), this.pointCreator.activate();
          break;

        case u.SamplingComposite:
          this.menu.activateToolAtIndex(1), this.toggleTool({
            index: 1,
            selected: !0
          }), this.pointCreator.activate();
      }
    }
  }, {
    key: "setToolbarMenuInset",
    value: function setToolbarMenuInset(t) {
      var e = t ? [t] : [];
      return this.autoPan.setInsets(e), e;
    }
  }, {
    key: "setViewOnly",
    value: function setViewOnly(t) {
      this.viewOnly !== t && (this.viewOnly = t);
    }
  }, {
    key: "startTrace",
    value: function startTrace(t) {
      this.setAutoTracing(t), this.isTracing = !0, this.prevUnTraced = this.unTraced, this.autoPan.activate(), this._updateTraceSites(this._cloneGraphics(this.sites), !0), this._resetGraphics(), this._createTraceListeners(), this._clearSelections();
    }
  }, {
    key: "stopTrace",
    value: function stopTrace() {
      this.traceSites.sort(function (t, e) {
        return t.attributes[w.sequenceID] - e.attributes[w.sequenceID];
      }), this._updateSites(this.traceSites, !0), this._clearSelections(), this._clearTrace();
    }
  }, {
    key: "toggleTool",
    value: function toggleTool(t) {
      var _this30 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = this.activeTool;
      this.reset().then(function () {
        var s = null;

        if (t.selected) {
          switch (t.index) {
            case 0:
              s = u.SamplingAddSelect;
              break;

            case 1:
              s = u.SamplingComposite;
          }

          _this30.moveLayersToTop();
        }

        i !== s ? _this30.initActivation({
          tool: s,
          activate: null != s,
          byPassShare: !1,
          forceUpdate: e
        }, _this30._activateTool) : (_this30.setActiveTool(i), _this30._applyToolListeners(_this30.activeTool)), _this30._updateMapCursor(), e && _this30.forceUpdate(), _this30._resetGraphics();
      });
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this31 = this;

      _get(_getPrototypeOf(SamplingTools.prototype), "undo", this).call(this, this.history, function (t) {
        return _this31._applyHistoryState(t);
      });
    }
  }, {
    key: "undoGrid",
    value: function undoGrid() {
      var _this32 = this;

      _get(_getPrototypeOf(SamplingTools.prototype), "undo", this).call(this, this.gridHistory, function (t) {
        return _this32._applyGridHistoryState(t);
      });
    }
  }, {
    key: "undoTrace",
    value: function undoTrace() {
      var _this33 = this;

      _get(_getPrototypeOf(SamplingTools.prototype), "undo", this).call(this, this.traceHistory, function (t) {
        return _this33._applyTraceHistoryState(t);
      });
    }
  }, {
    key: "updateSelectedSites",
    value: function updateSelectedSites(t) {
      var _this34 = this;

      var e = [],
          i = [];
      this.layer && (this.layer.graphics.forEach(function (s) {
        t.has(s.attributes.POINTGUID) ? (s.attributes.selected = 1, s.symbol = _this34._getSymbol(s), e.push(s)) : (s.attributes.selected = 0, s.symbol = _this34._getSymbol(s)), i.push(s);
      }), this.selectedSites = e, this.sites = i, this.forceUpdate());
    }
  }]);

  return SamplingTools;
}(d);

export { M as G, SamplingTools as S, isSampleLabelComposite as i, updateSampleLabelSequence as u };